import { render } from "./ConfirmActionModal.vue?vue&type=template&id=23753945&scoped=true"
import script from "./ConfirmActionModal.vue?vue&type=script&lang=js"
export * from "./ConfirmActionModal.vue?vue&type=script&lang=js"

import "./ConfirmActionModal.vue?vue&type=style&index=0&id=23753945&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23753945"]])

export default __exports__